module.exports = __webpack_public_path__ + "assets/images/amira-tutor-icon.b58117abfe312b8c1e4295ff593786c6.svg";